import { apiClient } from "./ApiClient";
import { API_URLS } from "../constants";

export const ProfileService = {
  getProfile: async () => {
    try {
      const { data } = await apiClient.get(API_URLS.USER.PROFILE);
      return data;
    } catch (error) {
      throw error;
    }
  },

  updateProfile: async (profileData) => {
    try {
      const { data } = await apiClient.put(API_URLS.USER.PROFILE, profileData);
      return data;
    } catch (error) {
      throw error;
    }
  },
};
